import {
  RequestNCDHHSExportDialog,
  RequestMeridianILExportDialog,
  RequestNjRhtExportDialog,
  RequestAllMarketsExportDialog,
} from "./request-export-dialog";
import { ExportHistoryTable } from "./export-history-table";
import { useExportUpdates } from "@/lib/hooks/use-export-updates";
import { UserContactExportDialog } from "./user-contact-export-dialog";

export function ExportsPage() {
  useExportUpdates();

  return (
    <div className="p-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold leading-7 text-black">
          Data Exports
        </h2>
        <div className="flex items-center gap-2">
          <RequestNCDHHSExportDialog />
          <RequestMeridianILExportDialog />
          <RequestNjRhtExportDialog />
          <RequestAllMarketsExportDialog />
          <UserContactExportDialog />
        </div>
      </div>

      <div className="mt-6">
        <ExportHistoryTable />
      </div>
    </div>
  );
}
